import React, { useState } from "react";
import Calc from "../components/Calc";
import Fields from "../components/Fields";
import "./style/home.css";

function Home() {
  const All = [
    {
      field: "Mathématique",
      matieres: [
        {
          name: "Mathématique",
          fois: 4,
        },
        {
          name: "Physique",
          fois: 4,
        },
        {
          name: "Science",
          fois: 1,
        },
        {
          name: "Philo",
          fois: 1,
        },
        {
          name: "Francais",
          fois: 1,
        },
        {
          name: "Anglais",
          fois: 1,
        },
        {
          name: "Arabe",
          fois: 1,
        },
        {
          name: "Info",
          fois: 1,
        },
        {
          name: "Option",
          fois: 2,
        },
        {
          name: "Sport",
          fois: 1,
        },
      ],
      formule : "4 * result + 2 * val.Mathématique + 1.5 * val.Physique + 0.5 * val.Science + 1 * val.Francais + 1 * val.Anglais"
    },
    {
      field: "Technique",
      matieres: [
        {
          name: "Mathématique",
          fois: 3,
        },
        {
          name: "Physique",
          fois: 3,
        },
        {
          name: "Technique",
          fois: 4,
        },
        {
          name: "Philo",
          fois: 1,
        },
        {
          name: "Francais",
          fois: 1,
        },
        {
          name: "Anglais",
          fois: 1,
        },
        {
          name: "Arabe",
          fois: 1,
        },
        {
          name: "Info",
          fois: 1,
        },
        {
          name: "Option",
          fois: 2,
        },
        {
          name: "Sport",
          fois: 1,
        },
      ],
      formule : "4 * result + 1.5 * val.Mathématique + 1 * val.Physique + 1.5 * val.Technique  + 1 * val.Francais + 1 * val.Anglais"
    },
    {
      field: "Sciences",
      matieres: [
        {
          name: "Mathématique",
          fois: 3,
        },
        {
          name: "Physique",
          fois: 4,
        },
        {
          name: "Science",
          fois: 4,
        },
        {
          name: "Philo",
          fois: 1,
        },
        {
          name: "Francais",
          fois: 1,
        },
        {
          name: "Anglais",
          fois: 1,
        },
        {
          name: "Arabe",
          fois: 1,
        },
        {
          name: "Info",
          fois: 1,
        },
        {
          name: "Option",
          fois: 2,
        },
        {
          name: "Sport",
          fois: 1,
        },
      ],
      formule : "4 * result + 1 * val.Mathématique + 1.5 * val.Physique + 1.5 * val.Science  + 1 * val.Francais + 1 * val.Anglais"
    },
    {
      field: "Informatique",
      matieres: [
        {
          name: "Mathématique",
          fois: 3,
        },
        {
          name: "Physique",
          fois: 3,
        },
        {
          name: "Algo",
          fois: 3,
        },
        {
          name: "BD",
          fois: 1.5,
        },
        {
          name: "Tic",
          fois: 1.5,
        },
        {
          name: "Philo",
          fois: 1,
        },
        {
          name: "Francais",
          fois: 1,
        },
        {
          name: "Anglais",
          fois: 1,
        },
        {
          name: "Arabe",
          fois: 1,
        },
        {
          name: "Option",
          fois: 2,
        },
        {
          name: "Sport",
          fois: 1,
        },
      ],
      formule : "4 * result + 1.5 * val.Mathématique + 1.5 * val.Algo + 0.25 *  val.Tic + 0.25 * val.BD + 0.5 * val.Physique  + 1 * val.Francais + 1 * val.Anglais"
    },
    {
      field: "Lettres",
      matieres: [
        {
          name: "Philo",
          fois: 4,
        },
        {
          name: "Francais",
          fois: 2,
        },
        {
          name: "Arabe",
          fois: 4,
        },
        {
          name: "Anglais",
          fois: 2,
        },
        {
          name: "Islamique",
          fois: 1,
        },
        {
          name: "His & Geo",
          fois: 3,
        },
        {
          name: "Info",
          fois: 1,
        },
        {
          name: "Option",
          fois: 2,
        },
        {
          name: "Sport",
          fois: 1,
        },
      ],
      formule : "4 * result + .5 * val.Arabe + 1.5 * val.Philo + 1 * val.His & Geo  + 1 * val.Francais + 1 * val.Anglais"
    },
    {
      field: "éco & gestion",
      matieres: [
        {
          name: "éco",
          fois: 3,
        },
        {
          name: "Gestion",
          fois: 3,
        },
        {
          name: "Mathématique",
          fois: 2,
        },
        {
          name: "His & Geo",
          fois: 2,
        },
        {
          name: "Philo",
          fois: 1,
        },
        {
          name: "Francais",
          fois: 1,
        },
        {
          name: "Anglais",
          fois: 1,
        },
        {
          name: "Arabe",
          fois: 1,
        },
        {
          name: "Info",
          fois: 1,
        },
        {
          name: "Option",
          fois: 2,
        },
        {
          name: "Sport",
          fois: 1,
        },
      ],
      formule : "4 * result + .5 * val.Mathématique + 1.5 * val.éco  + 1.5 * Gestion + 1 * val.Francais + 1 * val.Anglais"
    },
  ];
  const [Selected, setSelected] = useState("");
  function hundleSelection(el) {
    const found = All.find(element => element.field === el);
    setSelected(found);
  }
  return (
    <div className="home">
      {Selected === "" && <Fields hundleSelection={hundleSelection} />}
      {Selected != "" && <Calc fields={Selected}/>}
      {Selected != "" && <div onClick={()=>{setSelected("")}} className="back"><img src="images/arrow.svg" alt="" /></div>}
    </div>
  );
}

export default Home;
